<template>
  <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>

    <div class="form-container">
      <h3 style="text-align: left;">Cierre de Proceso</h3>
      <!-- Cierre de Proceso -->
      <div class="form-grid">
        <div class="form-group">
          <label for="num-certificado" >Número de certificado</label>
          <input
            type="text"
            id="num-certificado"
            v-model="formData.numCertificado"
          />
        </div>
        <div class="form-group">
          <label for="fecha-emision">Fecha de emisión</label>
          <input
            type="date"
            id="fecha-emision"
            v-model="formData.fechaEmision"
          />
        </div>
        <div class="form-group">
          <label for="fecha-contratacion">Fecha de contratación</label>
          <input
            type="date"
            id="fecha-contratacion"
            v-model="formData.fechaContratacion"
          />
        </div>
        <div class="form-group">
          <label for="tecnologia-contratacion">Tecnología de contratación o tipo de carga</label>
          <input
            type="text"
            id="tecnologia-contratacion"
            v-model="formData.tecnologiaContratacion"
          />
        </div>
        <div class="form-group">
          <label for="fecha-asignacion-inspector">Fecha de asignación a inspector</label>
          <input
            type="date"
            id="fecha-asignacion-inspector"
            v-model="formData.fechaAsignacionInspector"
          />
        </div>
      </div>
  
      <h3 style="text-align: left;">Información de Cliente Intermedio</h3>
      <!-- Información de Cliente Intermedio -->
      <div class="form-grid">
        <div class="form-group">
          <label for="nombre-cliente">Nombre</label>
          <input type="text" id="nombre-cliente" v-model="formData.nombre" />
        </div>
        <div class="form-group">
          <label for="email-cliente">Email</label>
          <input type="email" id="email-cliente" v-model="formData.email" />
        </div>
        <div class="form-group">
          <label for="telefono-cliente">Teléfono</label>
          <input type="tel" id="telefono-cliente" v-model="formData.telefono" />
        </div>
      </div>
  
      <h3 style="text-align: left;">Informe Resolutivo/Estudio de Instalaciones de CENACE</h3>
      <!-- Informe Resolutivo/Estudio de Instalaciones de CENACE -->
      <div class="form-grid">
        <div class="form-group">
          <label for="dependencia">Dependencia</label>
          <input type="text" id="dependencia" v-model="formData.dependencia" />
        </div>
        <div class="form-group">
          <label for="division">División</label>
          <input type="text" id="division" v-model="formData.division" />
        </div>
        <div class="form-group">
          <label for="zona">Zona</label>
          <input type="text" id="zona" v-model="formData.zona" />
        </div>
        <div class="form-group">
          <label for="numero">Número</label>
          <input type="text" id="numero" v-model="formData.numero" />
        </div>
        <div class="form-group">
          <label for="fecha-informe">Fecha</label>
          <input type="date" id="fecha-informe" v-model="formData.fecha" />
        </div>
        <div class="form-group">
          <label for="puesto-firma">Puesto de quien firma</label>
          <input type="text" id="puesto-firma" v-model="formData.puestoFirma" />
        </div>
        <div class="form-group">
          <label for="nombre-firma">Nombre de quien firma</label>
          <input type="text" id="nombre-firma" v-model="formData.nombreFirma" />
        </div>
        <div class="form-group">
          <label for="lugar">Lugar</label>
          <input type="text" id="lugar" v-model="formData.lugar" />
        </div>
      </div>
  
      <!-- Botón para enviar todos los datos -->
      <button v-if="existenDatos == false" @click="guardar" class="btn" style="background-color: #F49315; color: white;">Enviar Todos los Datos</button>
      <button v-if="existenDatos == true" @click="actualizar" class="btn" style="background-color: #F49315; color: white;">Actualizar Todos los Datos</button>

    </div>
  </template>
  
  <script>
  import { reactive } from "vue";
  import axios from "axios";
  import Swal from 'sweetalert2';
  
  export default {
    data() {
        return {
            isLoading:false,
            formData:{
                // Cierre de Proceso
                numCertificado: "",
                fechaEmision: "",
                fechaContratacion: "",
                tecnologiaContratacion: "",
                fechaAsignacionInspector: "",
                // Información de Cliente Intermedio
                nombre: "",
                email: "",
                telefono: "",
                // Informe Resolutivo/Estudio de Instalaciones de CENACE
                dependencia: "",
                division: "",
                zona: "",
                numero: "",
                fecha: "",
                puestoFirma: "",
                nombreFirma: "",
                lugar: "",
                id:""
            },
            existenDatos:false
        }
    },
    created() {
        this.consultar()
    },
    methods: {
        guardar(){
            var idcotizacion = localStorage.getItem('idcotizacion');
            var usuario = localStorage.getItem('email');
            this.formData.idcotizacion = idcotizacion;
            this.formData.usuario = usuario;
            this.formData.idinspeccion = localStorage.getItem('idinspeccion');
            axios.post(this.$rutaServer+'guardarCierreProceso', this.formData)
                .then(response => {
                    if (response.status == 201) {
                        Swal.fire('¡Éxito!', 'Datos registrados', 'success');
                        /*this.validation.nombre = '';
                        this.validation.email = '';
                        this.validation.telefono = '';*/
                    }
                })
                .catch(error => {
                    /*if(error.response.data.errors?.nombre?.[0]){
                                this.validation.nombre = error.response.data.errors?.nombre?.[0];
                            }
                            if(error.response.data.errors?.email?.[0]){
                                this.validation.email = error.response.data.errors?.email?.[0];
                            }
                            if(error.response.data.errors?.telefono?.[0]){
                                this.validation.telefono = error.response.data.errors?.telefono?.[0];
                            }*/
                });
        },
        consultar(){
            this.isLoading = true;
            var idinspeccion = localStorage.getItem('idinspeccion');
            axios.post(this.$rutaServer+'consultarCierreProceso', {idinspeccion:idinspeccion})
                .then(response => {
                    if(response.status == 200){
                        this.isLoading = false;
                        if(response.data.data.length > 0 ){
                            this.existenDatos = true;
                            this.formData = response.data.data[0];
                        }

                    }
                    
                })
                .catch(error => {
                    /*if(error.response.data.errors?.nombre?.[0]){
                                this.validation.nombre = error.response.data.errors?.nombre?.[0];
                            }
                            if(error.response.data.errors?.email?.[0]){
                                this.validation.email = error.response.data.errors?.email?.[0];
                            }
                            if(error.response.data.errors?.telefono?.[0]){
                                this.validation.telefono = error.response.data.errors?.telefono?.[0];
                            }*/
                });
        },
        actualizar(){
            var idcotizacion = localStorage.getItem('idcotizacion');
            var usuario = localStorage.getItem('email');
            this.formData.idcotizacion = idcotizacion;
            this.formData.usuario = usuario;
            this.formData.idinspeccion = localStorage.getItem('idinspeccion');
            axios.post(this.$rutaServer+'actualizarCierreProceso', this.formData)
                .then(response => {
                    if (response.status == 200) {
                        Swal.fire('¡Éxito!', 'Datos actualizados', 'success');
                        /*this.validation.nombre = '';
                        this.validation.email = '';
                        this.validation.telefono = '';*/
                    }
                })
                .catch(error => {
                    /*if(error.response.data.errors?.nombre?.[0]){
                                this.validation.nombre = error.response.data.errors?.nombre?.[0];
                            }
                            if(error.response.data.errors?.email?.[0]){
                                this.validation.email = error.response.data.errors?.email?.[0];
                            }
                            if(error.response.data.errors?.telefono?.[0]){
                                this.validation.telefono = error.response.data.errors?.telefono?.[0];
                            }*/
                });
        },
    },
   
  };
  </script>
  
  <style scoped>
  .form-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
  }
  
  h3 {
    margin-bottom: 15px;
    font-size: 20px;
    color: #444;
  }
  
  .form-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* Tres columnas de igual ancho */
    gap: 20px;
    margin-bottom: 20px;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  label {
    display: block;
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  input[type="text"],
  input[type="email"],
  input[type="tel"],
  input[type="date"] {
    width: 100%;
    padding: 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
  }
  
 
  </style>
  